module.exports = __webpack_public_path__ + "static/media/done-all-outline.9d2fcbca.svg";